import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";
import { useReveal } from "@/lib/useReveal";

export default function SectionLabel({ children, className = "" }) {
  const [ref, visible] = useReveal();
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 12 }}
      animate={visible ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5 }}
      className={`flex items-center gap-3 ${className}`}
    >
      <span className="h-px w-8 bg-primary" />
      <span className="label-tag">{children}</span>
    </motion.div>
  );
}
